"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Dropdown = require("./Dropdown.styles");

var _DropdownMenuItem = _interopRequireDefault(require("./DropdownMenuItem"));

var _Dropdown2 = require("./Dropdown.provider");

var _elements = require("../../styles/elements");

var DropdownMenu = function DropdownMenu(_ref) {
  var className = _ref.className,
      children = _ref.children;

  var _useContext = (0, _react.useContext)(_Dropdown2.DropdownContext),
      emptyHint = _useContext.emptyHint;

  var childrenArray = _react["default"].Children.toArray(children);

  if (childrenArray.length) {
    return (0, _jsxRuntime.jsx)("ul", {
      tabIndex: 0,
      role: "menu",
      css: _elements.list.styles.preflight,
      className: className,
      children: children
    });
  } // Empty menu


  return (0, _jsxRuntime.jsx)("div", {
    css: [_Dropdown.styles.item, _elements.text.styles.italic, _elements.text.styles.textMediumDark, process.env.NODE_ENV === "production" ? "" : ";label:DropdownMenu;"],
    className: "grui py-5",
    children: emptyHint
  });
};

DropdownMenu.propTypes = {
  className: _propTypes.string,
  children: _propTypes.node
};
DropdownMenu.defaultProps = {
  className: undefined,
  children: undefined
};
DropdownMenu.Item = _DropdownMenuItem["default"];
var _default = DropdownMenu;
exports["default"] = _default;
//# sourceMappingURL=DropdownMenu.js.map